import React from "react";
import classnames from "classnames";

import {
    phases,
    licenses,
    steps,
    phasesDisplay,
    licensesDisplay,
    constToCSS
} from "../../reducers/download";

import ToolTip from "../tool-tip";

const DownloadLicenseSwitch = props => {
    let { download, downloadSelectLicense } = props;
    let { status, license, pendingDownload } = download;

    if (!license) {
        license = licenses.ROYALTY_FREE;
    }

    let licenseSteps = steps[license];

    if (status != phases.INITIAL && status != phases.SELECT_LICENSE) {
        if (
            (status == phases.DOWNLOAD_READY &&
                license != licenses.CREATIVE_COMMONS) ||
            download.isRepurchasing
        ) {
            return null;
        }

        let licenseOptions = [
            licenses.ROYALTY_FREE,
            licenses.CREATIVE_COMMONS
        ].map(licenseOption => {
            let licenseDisplay = licensesDisplay[licenseOption];
            let licenseText = licenseDisplay.title;
            let current = licenseOption == license;
            let licenseClasses = classnames("license-option", {
                current
            });

            let licenseAction;
            if (!current) {
                licenseAction = props.onLicenseClick.bind(null, licenseOption);
            }

            return (
                <li
                    className={licenseClasses}
                    key={licenseOption}
                    onClick={licenseAction}
                >
                    {licenseText}
                </li>
            );
        });

        let navClass = classnames("download-flow-license-switch");
        return (
            <nav className={navClass}>
                <ul className="download-license-choices pill-options">
                    {licenseOptions}
                </ul>
                <ToolTip>
                    <p>
                        <b>Pro</b> allows you to use and edit icons without
                        attributing the creator. You purchase a Royalty–Free
                        license for unlimited use on any project, forever. Your
                        purchase directly supports the creator.
                    </p>
                    <p>
                        <b>Basic</b> means you must attribute the creator per
                        the Creative Commons Attribution license requirements.
                    </p>
                    <a href="http://help.thenounproject.com" target="_blank">
                        Get more help
                    </a>
                </ToolTip>
            </nav>
        );
    } else {
        return null;
    }
};

export default DownloadLicenseSwitch;
